import React from "react";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import CustomerModal from "../../Componate/CustomerModal";
import ReservationDetails from "./ReservationDetails";
import HallRoomDetailsList from "./HallRoomDetailsList";
import PaymentDetails from "./PaymentDetails";

const AddHallBookingForm = ({
  values,
  errors,
  handleChange,
  handleHallChange,
  handleSubmit,
  loading,
  formdata,
  setValues,
  hallRoomTypes,
  paymentMethods,
  // Customer props
  showModal,
  setShowModal,
  modalTitle,
  setModalTitle,
  customerType,
  setCustomerType,
  setSelectedCustomerId,
  existingCustomers,
  setExistingCustomers,
  handleDeleteCustomer,
  validateCustomer,
  setNewCustomerData,
  customerFormRef,
  // Hall management props
  halls,
  addHall,
  removeHall,
  billingRates,
  foodPackages = [],
  foodPackageDetails = {},
  isHallSectionEnabled = false
}) => {
  const [selectedCustomerObj, setSelectedCustomerObj] = React.useState(null);



  const handleConfirm = () => {
    if (customerType === "existing" || customerType === "check-in-customer") {
      if (!selectedCustomerObj) return;
      setExistingCustomers(prev => {
        const exists = prev.some(c => String(c.customer_id) === String(selectedCustomerObj.customer_id));
        return exists ? prev : [...prev, selectedCustomerObj];
      });
      setSelectedCustomerId(selectedCustomerObj.customer_id);
      setValues(prev => ({ ...prev, customer_id: selectedCustomerObj.customer_id }));
    }
    setShowModal(false);
  };


  const optionConfig = {
    hallroom_type_id: {
      list: hallRoomTypes ? Array.from(new Map(hallRoomTypes.map(item => [item.hallroom_type, item])).values()) : [],
      valueKey: "id",
      labelKey: "hallroom_type",
    },

    payment_method_id: {
      list: paymentMethods,
      valueKey: "id",
      labelKey: "method_name",
    },
    event_type: {
      list: [
        { id: "Wedding", name: "Wedding" },
        { id: "Conference", name: "Conference" },
        { id: "Meeting", name: "Meeting" },
        { id: "Party", name: "Party" },
      ],
      valueKey: "id",
      labelKey: "name",
    },
    food_package_id: {
      list: foodPackages,
      valueKey: "package_id",
      labelKey: "package_name",
    }
  };

  return (
    <>
      <PageBody
        onSubmit={handleSubmit}
        headerchildren={<HeadingOne>Create Hall Booking</HeadingOne>}
        card={false}
      >

        {/* 1. Hall Room Reservation Details */}
        <ReservationDetails
          formdata={formdata}
          values={values}
          errors={errors}
          handleChange={handleChange}
          optionConfig={optionConfig}
        />

        {/* 2. Hall Room Details */}
        <HallRoomDetailsList
          halls={halls}
          handleHallChange={handleHallChange}
          formdata={formdata}
          optionConfig={optionConfig}
          errors={errors}
          addHall={addHall}
          removeHall={removeHall}
          setCustomerType={setCustomerType}
          setModalTitle={setModalTitle}
          setShowModal={setShowModal}
          existingCustomers={existingCustomers}
          values={values}
          setSelectedCustomerId={setSelectedCustomerId}
          setValues={setValues}
          handleDeleteCustomer={handleDeleteCustomer}
          validateCustomer={validateCustomer}
          foodPackageDetails={foodPackageDetails}
          hallRoomTypes={hallRoomTypes}
          isHallSectionEnabled={isHallSectionEnabled}
        />

        {/* 3. Payments Details */}
        <PaymentDetails
          formdata={formdata}
          values={values}
          errors={errors}
          handleChange={handleChange}
          optionConfig={optionConfig}
          billingRates={billingRates}
        />

        <FormSubmitButton
          label="Create Booking"
          loading={loading}
          colSize="col-12"
          align="end"
          className="mt-4"
        />


      </PageBody>
      {/* Modals */}
      <CustomerModal
        showModal={showModal}
        setShowModal={setShowModal}
        customerType={customerType}
        setCustomerType={setCustomerType}
        modalTitle={modalTitle}
        setModalTitle={setModalTitle}
        setSelectedCustomerObj={setSelectedCustomerObj}
        setSelectedCustomerId={setSelectedCustomerId}
        customerFormRef={customerFormRef}
        setNewCustomerData={setNewCustomerData}
        handleConfirm={handleConfirm}
        errors={errors}
      />
    </>
  );
};

export default AddHallBookingForm;
